import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../redux/actions.js';
import MenuItem from 'material-ui/MenuItem';
import Close from 'material-ui/svg-icons/navigation/close';

const mapDispatchToProps = (dispatch) => ({
    onLogout: () => dispatch(logout())
});

const mapStateToProps = ({auth: {logged}}) => ({logged});

const Logout = ( { onLogout, logged }) => {
    if(logged) {
        return <MenuItem leftIcon={<Close color="#8c0808"/>} onTouchTap={onLogout}>
            <span style={{color: "#8c0808", fontWeight: 900, fontSize: "22px"}}>
                    Logout
            </span>
        </MenuItem>;
    } else {
        return null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout)


// WEBPACK FOOTER //
// ./src/components/auth/Logout.js